export const UPDATE_REPORTS_UI_STATE = "UPDATE_REPORTS_UI_STATE"
export const RU_LOAD_MORE = "RU_LOAD_MORE"
export const RU_CREATED = "RU_CREATED"
export const RU_DELETED = "RU_DELETED"
export const RU_UPDATED = "RU_UPDATED"
